import { render } from "./CustomChatLoading.vue?vue&type=template&id=7127b5bf&ts=true"
import script from "./CustomChatLoading.vue?vue&type=script&lang=ts"
export * from "./CustomChatLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__